<span [ngClass]='classList'>
  {{content}}
</span>
